import { useUIOnlyFeatureFlag } from "~/hooks/useUIOnlyFeatureFlag";
export function useIsPageHeaderVNextEnabled(): boolean {
    const [isPageHeaderVNextEnabled] = useIsPageHeaderVNextFeature();
    return isPageHeaderVNextEnabled;
}
export function useIsPageHeaderVNextFeature() {
    return useUIOnlyFeatureFlag("Page Header Next", false);
}
